export default "__VITE_PUBLIC_ASSET__eafa5a0c__"